/**
 * EmailBox
 */
window.EmailBox = {
    settings: {
        route: 'emailBox',
        routePrefs: 'prefsNylas',
        listing: 'emailBoxListing',
        listingLinked: 'emailBoxLinkedListing',
        filterName: 'emailBoxFilterForm',
        filterPrefix: 'emailBoxListing_filter_',
        popupWidth: 1092,
        searchKey: 13,
        form: 'emailForm',
        docTypes : ['estimate','order','proforma','delivery','creditnote','invoice','purOrder','purDelivery','purInvoice','purCreditNote']
    },

    translations: {
        // Text
        confirmTrash: Loc.g("Voulez-vous vraiment déplacer cette conversation dans la corbeille ?"),
        confirmDelete: Loc.g("Voulez-vous vraiment supprimer cette conversation ?"),
        sendLoading: Loc.g("Envoi de l'email en cours (création du message, upload des pièces jointes...)"),
        // Button
        btnSave: Loc.g("Enregistrer"),
        btnConfirm: Loc.g("Valider"),
        btnCancel: Loc.g("Annuler"),
        btnClose: Loc.g("Fermer"),
        btnSend: Loc.g("Envoyer"),
        btnDelete: Loc.g("Supprimer"),
        btnReply: Loc.g("Répondre"),
        btnReplyAll: Loc.g("Répondre à tous"),
        btnForward: Loc.g("Transférer"),
        // Title
        titleDelete: Loc.g("Mettre à la corbeille"),
        // Notification
        sendError: Loc.g('L‘email n‘a pas été envoyé. Vous devez déconnecter puis reconnecter votre compte email.'),
        sendSuccess: Loc.g('Email placé dans la boîte d‘envoi. Il sera envoyé d‘ici quelques instants.'),
        scheduledSuccess: Loc.g('Email programmé et placé dans la boîte d‘envoi. Il sera envoyé à la date prévue.')
    },

    elements: {
        body: $('body'),
        form: $('#emailForm')
    },

    selectors: {
        tabWrapper: '#content_emailBox',
        inputSearch: '#emailBoxListing_input_search',
        inputFilterSearch: '#emailBoxListing_filter_search',
        inputUnread: '#emailBoxListing_input_unread',
        inputFilterUnread: '#emailBoxListing_filter_unread',
        inputStarred: '#emailBoxListing_input_starred',
        inputFilterStarred: '#emailBoxListing_filter_starred',
        btnSearch: '#emailBoxListing_btn_search',
        btnUpload: '.form-input.form-upload',
        wrapper: '.view-email'
    },

    /**
     * Bind events
     */
    bindEvents: function()
    {
        var self = this;

        self.elements.body.off('click', '.messages li header').on('click', '.messages li header', function(event) {
            if (!$(event.originalEvent.target).hasClass('link')) {
                event.preventDefault();
                event.stopPropagation();
                self.toggleMessage($(this));
            }
        });
        self.elements.body.off('click', '.messages li header .link.toggle').on('click', '.messages li header .link.toggle', function(event) {
            event.preventDefault();
            event.stopPropagation();
            self.toggleRecipients($(this));
        });
    },
    /**
     *
     * @param string type
     * @param integer id
     */
    listLinked: function(type, id)
    {
        var self = this;
        var wrapper = $(self.selectors.tabWrapper);

        if (wrapper.html() == '') {
            wrapper.html(MyWindow.getLoader());
            var options = {
                action : "listLinked",
                type   : type,
                id     : id
            };

            MyFacture.post(self.settings.route, options, function (data) {
                wrapper.html(data.listing);
                Listing.init(data.prefix);
                self.prepareFilterForm('emailBoxLinkedFilterForm', 'emailBoxLinkedListing');
                Qtip.init();
                MyFacture.customForm(self.selectors.tabWrapper);
            }, 'json');
        }
    },
    /**
     * Render message from database
     * @param string id
     * @param string folder
     * @param int staffid
     */
    preview: function(id, folder, staffid, messageId)
    {
        var self     = this;
        var staffid  = (undefined == staffid) ? '' : staffid;
        var settings = {
            title: false,
            class: self.settings.route+' email-preview',
            padding: false,
            width: 'large',
            buttons: [
                {
                    name: self.translations.btnClose,
                    action: function() {
                        Panel.prototype.close();
                    }
                }
            ],
            callback: function(data) {
                self.callBack(data);
                self.bindEvents();
                // Load all medias (inline)
                self.loadMedias();
                // Open first email or selected
                if (messageId !== undefined && $('#message_' + messageId).length == 1) {
                    self.toggleMessage('.messages li#message_' + messageId + ' header');
                    $('.sidepanel-content').animate({
                        scrollTop: $('#message_' + messageId).offset().top-120
                    });
                } else {
                    self.toggleMessage($('.messages li:first header'));
                    self.hidePreviouxReply();
                }

                // Init Qtip();
                Qtip.init();
                // Change title
                panel.setTitle($('.view-email').data('title'));
            },
            beforeClose: function(event, ui) {
                // Clean all current XHR
                MyFacture.cleanQueue();
            }
        };
        
        var panel   = new Panel(settings);
        var params  = {
            action: 'preview',
            id: id,
            folder: folder,
            staffid: staffid
        };
        panel.open(self.settings.route, params);
    },
    /**
     * Render thread message from Nylas
     * @param string id
     * @param string folder
     * @param string messageId
     */
    view: function(id, folder, messageId)
    {
        var self      = this;
        var settings  = {
            title: '',
            class: self.settings.route+' email-view',
            padding: false,
            width: 'large',
            buttons: [
                {
                    name: self.translations.btnForward,
                    class: 'btn btn-no-border',
                    action: function() {
                        self.forward($(self.selectors.wrapper).data('id'));
                    }
                },
                {
                    name: self.translations.btnReplyAll,
                    class: 'btn btn-no-border hide reply-all',
                    action: function() {
                        self.reply($(self.selectors.wrapper).data('id'), 'all', folder, $('#email_linkedid').val(), $('#email_linkedtype').val());
                    }
                },
                {
                    name: self.translations.btnReply,
                    class: 'btn btn-primary',
                    action: function () {
                        self.reply($(self.selectors.wrapper).data('id'), 'one', folder, $('#email_linkedid').val(), $('#email_linkedtype').val());
                    }
                }
            ],
            callback: function(data) {
                self.callBack(data);
                self.bindEvents();
                // Change title
                panel.setTitle($('.view-email').data('title'));
                // Check thread read
                if ('Y' == $('.view-email').data('unread')) {
                    var datas = {'action': 'toggleAction', 'value': 'N', 'type': 'unread', 'id': id};
                    MyFacture.post(self.settings.route, datas, function(data) {}, "json", true);
                }
                // Load all medias (inline)
                self.loadMedias();
                // Hide previous response in each message
                self.hidePreviouxReply();
                // Open first message
                if (messageId !== undefined && $('#message_' + messageId).length == 1) {
                    self.toggleMessage('.messages li#message_' + messageId + ' header');
                    $('.sidepanel-content').animate({
                        scrollTop: $('#message_' + messageId).offset().top-120
                    });
                } else {
                    self.toggleMessage('.messages li:first header');
                }
                // Show reply-all btn
                if ($('.recipients').first().find('span[tips]').length > 1) {
                    $('.btn.reply-all').removeClass('hide');
                }
                // Init Qtip;
                Qtip.init();
                // Detect ellipsis
                $('.messages .recipients').each(function() {
                    if (Math.round($(this).innerWidth()) < Math.round($(this)[0].scrollWidth)) {
                        $(this).siblings('.toggle').removeClass('hide');
                    }
                });
            },
            beforeClose: function(event, ui) {
                // Clean all current XHR
                MyFacture.cleanQueue();
            }
        };

        // Check thread read
        var current = $('#email_' + id);
        current.removeClass('unread');
        current.find('td[data-colname=unread] .chip').addClass('hide');
        
        var panel  = new Panel(settings);
        var params = {
            action: 'view',
            id: id,
            folder: folder,
            linkView: ($('input#listingname').val() == 'emailBoxListing') ? 'N' : 'Y'
        };
        panel.open(self.settings.route, params);
    },
    /**
     * Print current thread
     */
    print: function()
    {
        window.print();
    },
    /**
     * Open/close a message of one thread in modal view
     * @param string selector
     */
    toggleMessage: function(selector)
    {
        var item = $(selector).parent();
        item.find('.section').toggleClass('hide');
        item.toggleClass('open');

        return false;
    },
    /**
     * Delete a thread
     * @param string id
     * @param string type
     * @param string subject
     * @param int version
     */
    delete: function(id, type, subject, version)
    {
        var self = this;
        var datas = {'action': 'delete', 'id': id, 'type': type, 'subject': subject, 'version': version};
        MyFacture.post(self.settings.route, datas, function(data) {
            if (undefined != data.result && 'error' == data.result.type) {
                Push.error(Loc.g("Une erreur s‘est produite pendant la suppression, veuillez réessayer. Si le problème persiste merci de contacter notre support"));
            } else {
                if ('draft' == type) {
                    Push.success(Loc.g('Le brouillon a bien été supprimé'));
                } else if ('scheduled' == type || 'failed' == type) {
                    Push.success(Loc.g('Le conversation a bien été supprimée'));
                } else {
                    Push.success(Loc.g('La conversation a bien été déplacée dans la corbeille'));
                }
            }
            Panel.prototype.close();
            self.refreshCallback(data, true);
        }, 'json', true);
        return true;
    },
    /**
     * Move a thread
     * @param string id
     * @param string type
     * @param int version
     */
    move: function(src, dest)
    {
        var self = this;
        var datas = {'action': 'move', 'src': src, 'dest': dest};
        MyFacture.post(self.settings.route, datas, function(data) {
            if (undefined != data.result && 'error' == data.result.type) {
                Push.error(Loc.g("Une erreur s‘est produite pendant le déplacement de votre conversation. Si le problème persiste merci de contacter notre support"));
            } else {
                Push.success(Loc.g('La conversation a bien été déplacée dans la boîte de réception'));
            }
            Panel.prototype.close();
            self.refreshCallback(data, true);
        }, 'json', true);
        return true;
    },
    /**
     * Archive a thread
     * @param string id
     * @returns {boolean}
     */
    archive: function(id)
    {
        var self = this;
        var datas = {'action': 'archive', 'id': id};
        MyFacture.post(self.settings.route, datas, function(data) {
            if (undefined != data.result && 'error' == data.result.type) {
                Push.error(Loc.g("Une erreur s‘est produite pendant l‘archivage, veuillez réessayer. Si le problème persiste merci de contacter notre support"));
            } else {
                Push.success(Loc.g('La conversation a bien été archivée'));
            }
            self.refreshCallback(data, true);
        }, 'json', true);
        return true;
    },
    /**
     * Create a new message
     * @param int id
     * @param string type
     * @param string empty
     */
    create: function(id, type, empty, template)
    {
        var self     = this;
        var settings = {
            title: false,
            class: self.settings.route,
            width: 'large',
            buttons: [
                {
                    name: self.translations.btnSave,
                    class: 'btn btn-default',
                    action: function () {
                        EmailBox.save();
                    }
                },
                {
                    name: self.translations.btnSend,
                    class: 'btn btn-primary',
                    action: function () {
                        EmailBox.send();
                    }
                }
            ],
            callback: function() {
                self.initForm('N');
            },
            beforeClose: function() {
                // Save email in draft
                if (($('textarea.redactor').attr('contentChanged') || $('#email_subject').val() != '') && $('#email_sending').val() == 'N') {
                    EmailBox.save();
                }
            }
        };

        empty       = (undefined == empty) ? 'Y' : empty;
        var doctype = (jQuery.inArray(type, self.settings.docTypes) !== -1) ? DocOverview.getProperties(['doctype']).doctype : undefined;
        var panel   = new Panel(settings);
        var params  = {
            action: 'create',
            thirdid: $('#thirdid').val(),
            linkedid: id,
            linkedtype: type,
            doctype: doctype,
            empty: empty
        };

        if (template != undefined) {
            params.template = template;
            params.emailTemplate = template;
            switch (template) {
                case 'reminderMandate':
                    params.showPaymentLinks = 'N';
                    break;
                case 'chaseDoc':
                case 'chaseDocEstimate':
                    params.showPaymentLinks = 'Y';
                    break;
            }
        }

        panel.open(self.settings.route, params);
    },
    /**
     * Edit a draft message
     * @param string id
     */
    edit: function(id)
    {
        var self     = this;
        var settings = {
            title: false,
            class: self.settings.route,
            width: 'large',
            buttons: [
                {
                    name: self.translations.btnSave,
                    class: 'btn btn-default',
                    action: function () {
                        EmailBox.save();
                    }
                },
                {
                    name: self.translations.btnSend,
                    class: 'btn btn-primary',
                    action: function () {
                        EmailBox.send();
                    }
                }
            ],
            callback: function(data) {
                var isJson = true;
                try {
                    data = $.parseJSON(data);
                } catch(err) {
                    isJson = false;
                }
                if (undefined != data.result && isJson) {
                    if ('error' == data.result.type) {
                        Panel.prototype.close();
                        Push.error(data.result.message);
                    }
                } else {
                    self.initForm('Y');
                }
            },
            beforeClose: function() {
                // Save email in draft
                if ($('#email_sending').val() == 'N') {
                    EmailBox.save();
                }
            }
        };

        var panel  = new Panel(settings);
        var params = {
            action: 'edit',
            id: id
        };
        panel.open(self.settings.route, params);
    },
    /**
     * Save draft message
     */
    save: function()
    {
        var self    = this;
        var options = {
            success: function(data) {
                MyForm.processJson(data, self.settings.form);
                if (data.form.status === 'ok') {
                    Email.callbackRecord(data);
                    Push.success(window.i18n.__('Email enregistré dans vos brouillons.'));
                    Panel.prototype.loading(false, true);
                    $('#email_id', '#emailForm').val(data.email_id);
                    $('#email_version', '#emailForm').val(data.email_version);
                } else {
                    Push.error(data.result.message);
                    Panel.prototype.loading(false, true);
                }
            },
            dataType: 'json'
        };
        var data = {action: 'save'};
        MyForm.prepare(self.settings.form, self.settings.route+'&'+$.param(data), options, true);
        MyFacture.initEvent();

        self.submit(self.settings.form, false);
    },
    /**
     * Retry to send an email
     */
    retry: function(id)
    {
        var self = this;
        var datas = {'action': 'retry', 'id': id};
        MyFacture.post(self.settings.route, datas, function(data) {
            Panel.prototype.close();
            self.refreshCallback(data, true);
            Push.success(window.i18n.__('L‘email a été remis en fil d‘attente et sera envoyé d‘ici quelques instants.'));
        }, 'json', true);
        return true;
    },
    /**
     * Send message via Nylas
     */
    send: function()
    {
        var self    = this;
        var options = {
            success: function(data) {
                $('#email_sending').val('Y');
                EmailBox.sendCallback(data);
            },
            dataType: "json"
        };
        var data = {action: 'send'};
        MyForm.prepare(self.settings.form, self.settings.route+'&'+$.param(data), options, true);
        MyFacture.initEvent();

        self.submit(self.settings.form, true);
    },
    /**
     * Reply to a message
     * @param string id
     * @param string type
     * @param string folder
     * @param int linkedid
     * @param string linkedtype
     */
    reply: function (id, type, folder, linkedid, linkedtype)
    {
        var self     = this;
        var settings = {
            title: '',
            class: self.settings.route,
            width: 'large',
            buttons: [
                {
                    name: self.translations.btnSave,
                    class: 'btn btn-default',
                    action: function () {
                        EmailBox.save();
                    }
                },
                {
                    name: self.translations.btnSend,
                    class: 'btn btn-primary',
                    action: function () {
                        EmailBox.send();
                    }
                }
            ],
            callback: function() {
                self.prepareEditForm();
                Qtip.init();
            },
            beforeClose: function () {
                // Save email in draft
                if (($('textarea.redactor').attr('contentChanged') || $('#email_subject').val() != '') && $('#email_sending').val() == 'N') {
                    EmailBox.save();
                }
            }
        };

        var panel   = new Panel(settings);
        var params  = {
            action: 'reply',
            type: type,
            id: id,
            folder: folder,
            linkedid: linkedid,
            linkedtype: linkedtype,
            doctype: $('#email_doctype').val()
        };
        panel.open(self.settings.route, params);
    },
    /**
     * Forward a message
     * @param string id
     */
    forward: function(id)
    {
        var self     = this;
        var settings = {
            title: '',
            class: self.settings.route,
            width: 'large',
            buttons: [
                {
                    name: self.translations.btnSend,
                    class: 'btn btn-primary',
                    action: function () {
                        EmailBox.send();
                    }
                }
            ],
            callback: function() {
                self.prepareEditForm();
                Qtip.init();
            },
            beforeClose: function () {
                // Save email in draft
                if (($('textarea.redactor').attr('contentChanged') || $('#email_subject').val() != '') && $('#email_sending').val() == 'N') {
                    EmailBox.save();
                }
            }
        };
        var panel  = new Panel(settings);
        var params = {
            action: 'forward',
            id: id,
            linkedid: $('#email_linkedid').val(),
            linkedtpye: $('#email_linkedtype').val(),
            doctype: $('#email_doctype').val()
        };
        panel.open(self.settings.route, params);
    },
    /**
     * Download an attachment from a message
     * @param string id
     * @param string hash
     */
    download: function(id, hash)
    {
        var self  = this;
        var route = MyFacture.buildUrl(self.settings.route + '&action=download&id=' + id);
        if (hash != undefined) {
            route = route + '&hash=' + hash;
        }
        
        window.open(route, '_blank');
    },
    /**
     * Search (subject, body) in thread
     */
    search: function()
    {
        var self = this;

        $(self.selectors.inputFilterSearch).val($(self.selectors.inputSearch).val());
        // Clean all filters
        self.resetSearch();
        
        Listing.update(self.settings.listing, false, undefined, 'search');
    },
    /**
     * Reset filters (default value) on search request
     */
    resetSearch: function()
    {
        var self = this;

        $('input[name='+self.settings.filterPrefix+'folders]').each(function() {
            $(this).prop('checked', false);
        });
        $('select[name='+self.settings.filterPrefix+'unread]').val('');
        $('select[name='+self.settings.filterPrefix+'starred]').val('');
    },
    /**
     *
     * @param form
     * @param sendIt
     */
    submit: function(form, sendIt)
    {
        Panel.prototype.loading(true, true);
        if (sendIt === true) {
            $('#'+form).find('input[name=email_sendIt]').val('Y');
        } else {
            $('#'+form).find('input[name=email_sendIt]').val('N');
        }
        $('#'+form).submit();
    },
    /**
     * Callback for all call ajax
     * @param object data
     * @param bool forceClose
     */
    callBack: function(data, forceClose)
    {
        var forceClose = (undefined == forceClose) ? false : forceClose;
        var self = this;

        // Decode string if necessary
        var isJson = true;
        if (typeof data != 'object') {
            try {
                data = $.parseJSON(data);
            } catch(err) {
                isJson = false;
            }
        }
        
        if (undefined != data.result) {
            if ('error' == data.result.type) {
                Panel.prototype.close();
                Push.error(data.result.message);
                self.refreshCallback(data, true);
            } else {
                if (forceClose) {
                    Panel.prototype.close();
                }
            }
        }
    },
    /**
     * Callback for prepare form
     * @param edit
     */
    initForm: function(edit)
    {
        edit = (edit === undefined) ? "N" : edit;

        var self = this;
        var options = {
            dataType : "json",
            data : {
                action	: 'save',
                context : ''
            },
            success	: function(data) {
                self.recordCallback(data);
            }
        };

        // Button copy fields
        if ($('#__persistent__email_cc').length && $('#__persistent__email_cc').html().length > 0) {
            self.showField('fieldCc');
        }
        if ($('#__persistent__email_bcc').length && $('#__persistent__email_bcc').html().length > 0) {
            self.showField('fieldBcc');
        }

        MyForm.prepare(self.settings.formName, self.settings.route+"&", options, true);
        MyFacture.customForm();
        Qtip.init();
    },
    processForm: function(data)
    {
        var self = this;
        MyForm.processJson(data, self.settings.formName);
    },
    prepareForm: function(context)
    {
        var self = this;
        var options = {
            data : {
                action	: 'record',
                context : context
            },
            success: function(data) {
                self.recordCallback(data);
            },
            dataType: "json"
        };

        MyForm.prepare(self.settings.formName, self.settings.route, options, true);
        MyFacture.customForm();
    },
    prepareEditForm: function(nylas)
    {
        var self = this;
        var options = {
            success: function(data) {
                Email.callbackRecord(data);
            },
            dataType: "json"
        };
        var data = {action: 'recordEmail'};
        MyForm.prepare(self.settings.form, "emailBox&"+$.param(data), options, true);
        MyFacture.initEvent();
    },
    sendCallback: function(data) {
        var self = this;
        MyForm.processJson(data, self.settings.form);
        if ('ok' == data.form.status) {
            if (undefined != data.error) {
                Push.error(self.translations.sendError);
                Panel.prototype.loading(false, true);
            } else if (undefined != data.scheduled) {
                Panel.prototype.close();
                Push.success(self.translations.scheduledSuccess);
            } else {
                Panel.prototype.close();
                Push.success(self.translations.sendSuccess);
            }

            if (data.scheduled == 'Y') {
                window.EventBus.emit('email:scheduled', {emailId: data.queue_id, eventDetails: data.more})
            } else {
                window.EventBus.emit('email:sent', {emailId: data.queue_id, eventDetails: data.more})
            }
            if (data.form.redirect) {
                Utils.relocate(data.form.redirect);
            }
        } else {
            Panel.prototype.loading(false, true);
        }
    },
    /**
     *
     * @param data
     * @param refresh
     */
    refreshCallback: function(data, refresh)
    {
        var self = this;
        if (undefined != refresh) {
            Listing.update($('#listingname').val());
        }
    },
    /**
     * Filter listing
     */
    prepareFilterForm: function(filterName, listingName)
    {
        var self       = this;
        var options    = {success: function(data) {self.processFilterForm(data, listingName); }, dataType: "json"};
        var filterName = (undefined != filterName) ? filterName : self.settings.filterName;
        var action     = ('emailBoxLinkedListing' == listingName) ? 'updateListingLinked' : 'updateListing';

        MyForm.prepare(filterName, self.settings.route+"&action="+action, options);
        self.initTooltip();
        self.updateSidebar();
        self.elements.body.on('keyup', self.selectors.inputSearch, function(event) {
            var code = event.which;
            if (code == self.settings.searchKey) {
                event.preventDefault();
                self.search();
            }
        });
        self.elements.body.on('change', self.selectors.inputUnread, function(event) {
            var value = ($(event.target).is(':checked')) ? 'Y' : '';
            $(self.selectors.inputFilterUnread).val(value).trigger('change');
        });
        self.elements.body.on('change', self.selectors.inputStarred, function(event) {
            var value = ($(event.target).is(':checked')) ? 'Y' : '';
            $(self.selectors.inputFilterStarred).val(value).trigger('change');
        });
    },
    /**
     *
     * @param data
     */
    processFilterForm: function(data, listingName)
    {
        var self            = this;
        var listingName     = (undefined != listingName) ? listingName : self.settings.listing;
        var listingMetadata = listingName.replace('Listing', '');
        listingMetadata     = listingMetadata+'_metadatas';

        if (undefined != data.result && 'error' == data.result.type) {
            self.callBack(data);
            // Hide loader
            $("#"+listingName+"_loading").fadeOut();
            Listing.loader('hide', listingName);
        } else {
            Listing.refresh(listingName, data, data[listingMetadata]);
        }
        // Callback listing
        self.updateSidebar();
        if (undefined != data.isLast) {
            Push.warning(window.i18n.__('Aucune page supplémentaire.'));
        }
        self.initTooltip();
    },
    /**
     * Update sidebar height
     */
    updateSidebar: function()
    {
        $('.sidebar', '#layout-emailbox').css('height', $('.listing', '#layout-emailbox').height());
    },
    /**
     * Init tooltip for logs
     */
    initTooltip: function()
    {
        // Add tips for email logs
        $('[tips-logs]').each(function(){
            var id = $(this).attr('tips-logs');
            $(this).qtip({
                position: {
                    corner: {
                        target: 'leftMiddle',
                        tooltip: 'rightMiddle'
                    }
                },
                content: {
                    url: './?_f=emailBox',
                    data : {action: 'tipsLogs', id: id}
                },
                show: 'mouseover',
                hide: {when: 'mouseout', fixed: true, delay: 100},
                style: {
                    'width': 250,
                    'max-height': 300,
                    'overflow': 'scroll',
                    'border': { width: 1, color: 'rgba(53,89,110,0.1)'},
                    'textAlign': 'left',
                    'tip': false,
                    'padding': 10
                }
            });
        });
    },
    /**
     * Alert for confirm deletion
     * @param string id
     * @param string type
     * @param string subject
     * @param int version
     */
    confirmDelete: function(id, type, subject, version)
    {
        var self = this;
        var options = {
            resizable	: false,
            noclose		: true,
            type		: "warning",
            title		: self.translations.titleDelete,
            buttons		: [
                {text : self.translations.btnCancel, click : function() { $(this).dialog("close"); }},
                {text : self.translations.btnConfirm, click : function() { self.delete(id, type, subject, version); $(this).dialog("close"); }}
            ]
        };
        var content = ('thread' == type) ? self.translations.confirmTrash : self.translations.confirmDelete;
        MyWindow.alert(content, options);
    },
    /**
     * @param type
     * @param id
     * @returns {boolean}
     */
    toggleAction: function(type, id)
    {
        var self        = this;
        var elementList = $('#email_'+id);
        var elementView = $('#view_email_'+id);
        var element     = (elementView.length) ? elementView : elementList;
        var forceClose  = true;

        switch (type) {
            case 'starred':
                var value = (element.hasClass('starred')) ? 'N' : 'Y';
                if (elementList.length) {
                    elementList.find('td a').each(function() {
                        var link = $(this).attr('onclick');
                        if (typeof link !== typeof undefined && link !== false && true) {
                            if (/EmailBox.view\(([^\)]+)\)/.test(link)) {
                                if (link.indexOf("'Y'") !== -1) {
                                    link = link.replace("'Y'", "'N'");
                                } else {
                                    link = link.replace("'N'", "'Y'");
                                }
                                $(this).attr('onclick', link);
                            }
                        }
                    });
                    var iconStarred = elementList.find('td[data-colname=starred]');
                    iconStarred.find('.fa-bookmark').toggleClass('hide');
                    iconStarred.find('.fa-bookmark-o').toggleClass('hide');
                    var viewStarred = $('.messages .infos');
                    viewStarred.find('.fa-bookmark').toggleClass('hide');
                    viewStarred.find('.fa-bookmark-o').toggleClass('hide');
                }
                break;
            case 'unread':
                var value  = (element != undefined && element.hasClass('unread')) ? 'N' : 'Y';
                elementList.find('td[data-colname=unread] .chip').toggleClass('hide');
                break;
        }
        var datas   = {'action': 'toggleAction', 'value': value, 'type': type, 'id': id};

        // Update class
        elementList.toggleClass(type);
        if (elementView.length) {
            elementView.toggleClass(type);
        }
        
        // Call ajax
        MyFacture.post(self.settings.route, datas, function(data) { self.callBack(data, forceClose); }, "json", true);
        return true;
    },
    /**
     * Hide previous message in response
     */
    hidePreviouxReply: function()
    {
        var self = this;
        if ($('.messages li').length > 1) {
            $('article.body').each(function() {
                if (!$(this).find('.showReply').length) {
                    // Find provider separator email
                    var item = $(this).find('.gmail_extra:first');
                    if (!item.length) {
                        item = $(this).find('.gmail_quote:first');
                    }
                    if (!item.length) {
                        item = $(this).find('blockquote:first');
                    }
                    var scope        = item.parents('.message');
                    var btnShowReply = '<a href="#showReply" class="showReply my-1" onclick="EmailBox.showPreviousReply(\''+scope.attr('id')+'\');">...</a>';
                    item.hide();
                    item.before(btnShowReply);
                }
            });
        }
    },
    /**
     * Show previous message in response
     * @param parent
     */
    showPreviousReply: function(parent)
    {
        var reply = $('#'+parent).find('.showReply + .gmail_extra');
        if (!reply.length) {
            reply = $('#'+parent).find('.showReply + .gmail_quote');
        }
        if (!reply.length) {
            reply = $('#'+parent).find('.showReply + blockquote');
        }
        var btn   = $('#'+parent).find('.showReply');
        reply.toggle();
    },
    /**
     * Add template content in content email
     */
    switchTemplate : function()
    {
        var signature = $("#email_signature");
        var idtpl	  = $('select[name=email_template]').val();
        var template  = $('#templateTexts_'+idtpl);
        var subject   = $("#email_subject");
        var message   = $("#email_message");

        $('[e_autoattachement]').length > 0 && $('[e_autoattachement]').data('tokenInputObject').clear();

        if (template.length > 0) {
            var tpl = {
                subject		: template.find('input.subject').val(),
                message		: template.find('div.message').html(),
                attachments : template.attr('attachment_json') !== undefined ? JSON.parse(template.attr('attachment_json')) : []
            };
            
            $('#email-template-comment').show();
        } else {
            $('[e_autoattachement]').length > 0 && $('[e_autoattachement]').data('tokenInputObject').clear();
            var tpl = {
                subject		: '',
                message		: signature.html(

                ),
                attachments : []
            };
            
            $('#email-template-comment').hide();
        }

        // SUBJECT
        if (subject.data('redactor') != undefined) {
            subject.redactor("set", tpl.subject);
            subject.redactor("sync");
        } else {
            subject.val(tpl.subject);
        }

        // MESSAGE
        if (message.data('redactor') != undefined) {
            message.redactor("set", tpl.message);
            message.redactor("sync");
        }

        // ATTACHMENTS
        if (tpl.attachments.length > 0) {
            $.each(tpl.attachments, function(i, item){
                $('[e_autoattachement]').data('tokenInputObject').add(item);
            });
            $('#attachment').find('> a').hide().next().removeClass('hidden');
            $('.form-upload').removeClass('hidden');
        } else {
            $('#attachment').find('> a').show().removeClass('hide').next().addClass('hidden');
            $('.form-upload').addClass('hidden');
        }
    },
    /**
     *
     * @param select
     */
    switchStaff: function(select)
    {
        $('#emailBoxLinkedListing_filter_ownerid').val(select.val());
        $('#emailBoxLinkedListing_filter_accountid').val(select.find(':selected').attr('data-account'));
        Listing.update($('#listingname').val());
    },
    /**
     * @param element
     */
    toggleScheduled: function(element)
    {
        $(element).hide();
        $(element).next().removeClass('hidden');
        MyFacture.customForm('#emailForm');

        var date_min	= '';
        var date_format = $('[datepicker]').attr('format');
        $('[datepicker]').datepicker('option', 'minDate', 0);
    },
    /**
     *
     * @param element
     */
    toggleAttachment: function(element)
    {
        var self = this;
        $(element).hide();
        $(element).next().removeClass('hidden');
        $(self.selectors.btnUpload).removeClass('hidden');
    },
    /**
     *
     * @param element
     */
    toggleRecipients: function(element)
    {
        var item = $(element);
        var text = item.text();
        item.prev().toggleClass('expand');
        item.text(item.attr('data-toggle'));
        item.attr('data-toggle', text);

        return false;
    },
    /**
     *
     * @param field
     */
    showField: function(field)
    {
        var self      = this;
        var wrapper   = $('.emailBox #emailForm .fieldTo .form-input');
        var div       = $('.emailBox #emailForm .fieldTo .toggle-field');
        var className = (wrapper.hasClass('one')) ? 'two' : 'one';

        $('.'+field).removeClass('hide');
        $('.btn-'+field).addClass('hide');
        wrapper.addClass(className);
        div.addClass(className);
    },
    /**
     *
     * @param data
     */
    addAttachement: function(data)
    {
        if (data.success) {
            $('#email_attachment').tokenInput("add", {id:data.file_infos.file_id , name:data.file_infos.file_fullname});
        } else {
            if (data.file_infos !== undefined && data.file_infos.file_id !== undefined){
                $('#email_attachment').tokenInput("add", {id:data.file_infos.file_id , name:data.name});
                $('.qq-error-message').html("<span class='qq-error-fileadded'>"+Loc.g('Le fichier existe déjà mais a été liée à l’email')+"</div>");
            }
        }
    },
    /**
     * Load medias inline for each message of thread
     */
    loadMedias: function()
    {
        var self = this;

        $('.messages .message[data-medias]').each(function () {
            //var id        = $(this).data('id');
            var container = $(this).find('.body');
            var medias    = $(this).data('medias');
            var datas     = {'action': 'loadMedias', 'ids': medias};

            // Add overlay on each inline image (loading)
            container.find('img[data-src]').each(function() {
                var loader = MyWindow.getLoader();
                $(this).wrap('<div class="loading prelative"></div>');
                $(this).closest('.loading').prepend(loader);
                var logo = $('.loader-logo');
                logo.width($(this).width());
                logo.height($(this).height());
                $(this).prev().addClass('b-1');
            });

            MyFacture.send(EmailBox.settings.route, datas, function(data) {
                if (data.result != undefined) {
                    for (var cid in data.result) {
                        // Replace cid by data-image (base64)
                        var value   = data.result[cid];
                        var content = container.html();
                        if (content) {
                            content = content.replace('src="cid:'+cid+'"', 'src="'+value+'"');
                            container.html(content);
                            // Switch src attr by attr data-src
                            container.find('img[data-src]').each(function() {
                                $(this).attr('src', $(this).attr('data-src'));
                                $(this).removeAttr('data-src');
                                $(this).prev('.loader-logo').remove();
                                $(this).unwrap();
                            });
                        }
                    }
                }
            }, 'json', true);
        });
    },
    /**
     * Batch action for move thread in trash folder
     * @param array rowSelection
     */
    batchDelete: function(rowSelection)
    {
        var self = this;

        MyFacture.startWait();
        MyFacture.post(self.settings.route, {action: "batchDelete", rowSelection: rowSelection}, function (data) {
            MyFacture.stopWait();
            if (undefined != data.result && 'error' == data.result.type) {
                Push.error(data.result.message);
            }
            Listing.update(EmailBox.settings.listing);
        }, "json", true);
    },
    /**
     *
     * @param rowSelection
     */
    batchLink: function(rowSelection)
    {
        if (Array.isArray(rowSelection)) {
            var ids = [];
            for (var key in rowSelection) {
                ids.push(rowSelection[key].split("_")[1]);
            }
            EmailBoxLinked.confirm(ids);
        }
    },
    /**
     * Batch action for mark as read/unread thread
     * @param array rowSelection
     * @param string type
     */
    batchRead: function (rowSelection, type)
    {
        var self   = this;
        var action = (type) ? 'batchRead' : 'batchUnread';

        MyFacture.startWait();
        MyFacture.post(self.settings.route, {action: 'batchRead', rowSelection: rowSelection, type: type}, function (data) {
            MyFacture.stopWait();
            if (undefined != data.result && 'error' == data.result.type) {
                Push.error(data.result.message);
            }
            Listing.update(EmailBox.settings.listing);
        }, "json", true);
    },
    /**
     * Batch action for mark as starred/unstarred thread
     * @param array rowSelection
     * @param string type
     */
    batchStarred: function (rowSelection, type)
    {
        var self   = this;
        var action = (type) ? 'batchStarred' : 'batchUnstarred';

        MyFacture.startWait();
        MyFacture.post(self.settings.route, {action: 'batchStarred', rowSelection: rowSelection, type: type}, function (data) {
            MyFacture.stopWait();
            if (undefined != data.result && 'error' == data.result.type) {
                Push.error(data.result.message);
            }
            Listing.update(EmailBox.settings.listing);
        }, "json", true);
    },
    /**
     * Sync all folders for current account (cache)
     * @param id
     */
    launchSync: function (id) {
        var self = this;

        MyFacture.post(self.settings.routePrefs, {action: 'launchSync', id: id}, function (data) {
            setTimeout(function() {
                Utils.relocate('/?_f='+self.settings.route);
            }, 3000);
        }, "json");
    },
    /**
     * Load more messages fro current thread
     * @param string id
     * @param string folder
     * @param string starred
     * @param int nbMessages
     */
    loadMessages: function (id, folder, starred, nbMessages)
    {
        var self       = this;
        var loading    = MyWindow.getLoader();
        var pagination = $(self.selectors.wrapper).find('.email-pagination');
        pagination.toggleClass('hide');
        $(loading).insertAfter(pagination);

        MyFacture.post(self.settings.route, {
            action: 'loadMessages',
            'id': id,
            'folder': folder,
            'starred': starred,
            'nbMessages': nbMessages,
            'offset': parseInt($('ul.messages > li').length)
        }, function (data) {
            // Remove loader
            $(self.selectors.wrapper).find('.loader-logo').remove();
            $('ul.messages').append(data.result);
            var currentNbMessages = $('ul.messages > li').length;
            self.callBack(data);
            // Show pagination
            if (currentNbMessages < nbMessages) {
                pagination.toggleClass('hide');
            }
            self.bindEvents();
            // Load all medias (inline)
            self.loadMedias();
            // Hide previous response in each message
            self.hidePreviouxReply();
            // Init Qtip;
            Qtip.init();
            // Detect ellipsis
            $('.messages .recipients').each(function () {
                if (Math.round($(this).innerWidth()) < Math.round($(this)[0].scrollWidth)) {
                    $(this).siblings('.toggle').removeClass('hide');
                }
            });
        }, "json");
    }
};


/**
 * EmailBoxLinked
 */
window.EmailBoxLinked = {
    settings: {
        class: 'emailBoxLinkItem',
        listing: 'emailBoxLinkedListing'
    },

    translations: {
        titleLink: Loc.g("Liaison d‘email"),
        successAddLinked: Loc.g("L'objet a été créé et lié à votre email"),
        successAddLinkedBatch: Loc.g("L'objet a été créé et lié à vos emails"),
        successLinked: Loc.g("L'email a bien été lié"),
        successLinkedBatch: Loc.g("Les emails ont bien été liés"),
        errorLinked: Loc.g("Problème lors de la liaison de l'email. Veuillez réessayer dans un moment"),
        errorLinkedBatch: Loc.g("Problème lors de la liaison des emails. Veuillez réessayer dans un moment"),
        successDeleteLinked: Loc.g("La liaison sur la conversation a bien été supprimée"),
        errorDeleteLinked: Loc.g("Problème lors de la suppression de la liaison. Veuillez réessayer dans un moment"),
        btnLink: Loc.g("Lier l‘email"),
        confirmDelete: Loc.g("Voulez-vous vraiment supprimer la liaison sur cette conversation ?"),
        btnDelete: Loc.g("Supprimer la liaison")
    },

    selectors: {
        select: '.emailbox-linked-type',
        search: '#emailbox-linked-search',
        contact: '#emailbox-linked-search-contact',
        contactGroup: '.contact-group',
        wrapper: '#emailLink',
        validBtn: '#btn-valid',
        inputNewThird: '#docnewthird',
        inputNewPeople: '#newpeople',
        inputNewOpportunity: '#opportunityLinkedNew',
        autoSave: '.autoSave'
    },
    /**
     * bindEvents
     */
    bindEvents: function()
    {
        var self = this;
        if ($(self.selectors.wrapper).data('haslink') != '1') {
            self.isEnabled(false);
        }
        // Events
        $(self.selectors.search).change(function() {
            if ("" != $(this).val()) {
                self.isEnabled(true);
            } else {
                self.isEnabled(false);
            }
        });
        $(self.selectors.select).change(function() {
            self.search();
            self.cleanRadio();
            self.isEnabled(false);
            if ('contact' == $(this).val()) {
                TokenInput.autoPeople(self.selectors.contact, 1, 'true', '');
            }
            self.toggleContact('contact' == $(this).val());
            $(self.selectors.search).tokenInput('clear');
        });
        $(self.selectors.wrapper).find('input[name="type"]').change(function() {
            if ($(self.selectors.wrapper).find('input[name="type"]:checked').length > 0) {
                $(self.selectors.search).tokenInput('clear');
                $(self.selectors.contact).tokenInput('clear');
                self.isEnabled(true);
            } else {
                self.isEnabled(false);
            }
        });

        // Init people
        TokenInput.autoPeople(self.selectors.contact, 1, 'true', '');
        if ('contact' == $(self.selectors.select).val()) {
            // Add thirdid to contact autocomplete
            var value = $(self.selectors.search).val();
            var id    = value.split('_')[1];
            $(self.selectors.contact).tokenInput('more', 'thirdid_'+id);
        } else {
            self.toggleContact(false);
        }
    },
    /**
     * Modal for select type of link
     * @param array ids
     */
    confirm: function(ids)
    {
        var self = this;

        let successMethod = () => {
            var inputSerach = $(self.selectors.search);
            var inputContact = $(self.selectors.contact);
            // Get current folder
            var folder = $('.folder input[name="emailBoxListing_filter_folders"]:checked').val();

            if ("" != inputSerach.val()) {
                var linked = inputSerach.val();
                if ('people' == $(self.selectors.select).val() && -1 == linked.indexOf('_')) {
                    linked = 'people_' + linked;
                }
                var contact = inputContact.val();
                self.link(linked, contact, ids, folder);
            } else {
                self.addAndLink($('.add-object input[name=type]:checked').val(), ids, folder);
            }
        };
        EmailHelper.openLinkForm(ids, successMethod);
    },
    /**
     *
     * @param string linked
     * @param int contactid
     * @param array ids
     * @param string folder
     */
    link: function(linked, contactid, ids, folder)
    {
        var self = this;
        // Wierd case of id concatenation (ex: opportunity_1,opportunity2) NOT HANDLED by the back action.
        if (linked.indexOf(',') > 0) {
            linked = linked.split(',')[0];
        }
        // Save link
        MyWindow.wait();
        return MyFacture.post(EmailBox.settings.route, {action: 'saveLink', ids: ids, linked: linked, contact: contactid, folder: folder}, function(data) {
            if (data.success) {
                MyWindow.awake();
                MyWindow.close();
                if (ids.length > 1) {
                    Push.success(self.translations.successLinkedBatch);
                } else {
                    Push.success(self.translations.successLinked);
                }
                Listing.update(EmailBox.settings.listing);
            } else {
                MyWindow.close();
                if (ids.length > 1) {
                    Push.error(self.translations.errorLinkedBatch);
                } else {
                    Push.error(self.translations.errorLinked);
                }
            }
        }, 'json');
    },
    /**
     *
     * @param string type
     * @param array ids
     * @param string folder
     */
    addAndLink: function(type, ids, folder)
    {
        var self    = this;

        var options = {
            title : eval('self.translations.titleLink'+Utils.ucfirst(type)),
            width : EmailBox.settings.popupWidth,
            dialogClass : 'emailBoxLinkNew'
        };

        switch (type) {
            case 'third':
            case 'prospect':
            case 'supplier':
                var formId = 'emailLinkThirdForm';
                options.buttons	= [
                    {
                        text : EmailBox.translations.btnCancel,
                        class: 'btn btn-default',
                        click : function(){
                            $(this).dialog("close");
                        }
                    },
                    {
                        text : self.translations.btnLink,
                        class: 'btn btn-primary',
                        click : function(){
                            $("#"+formId).submit();
                        }
                    }
                ];
                options.callback = function(data) {
                    var options = {success:function(data) {
                        var formIsOk = MyForm.processJson(data, formId);
                        if (formIsOk) {
                            MyWindow.close();
                            if (ids.length > 1) {
                                Push.success(self.translations.successAddLinkedBatch)
                            } else {
                                Push.success(self.translations.successAddLinked)
                            }
                            Listing.update(EmailBox.settings.listing);
                        }
                    },
                        dataType: "json",
                        data: {action: "linkThird"}
                    };
                    MyForm.prepare(formId, "emailBox", options, true);
                    MyFacture.customForm();

                    // Force create third
                    $(self.selectors.inputNewThird).trigger('click');
                    DocTools.switchCreateForThird(ids);
                };
                MyWindow.load(EmailBox.settings.route, {action: 'linkThirdForm', ids: ids, folder: folder, type: type}, options);
                break;
            case 'contact':
                var formId = 'peopleLinkToForm';
                options.buttons	= [
                    {
                        text : EmailBox.translations.btnCancel,
                        class: 'btn btn-default',
                        click : function(){
                            $(this).dialog("close");
                        }
                    },
                    {
                        text : self.translations.btnLink,
                        class: 'btn btn-primary',
                        click : function(){
                            $("#"+formId).submit();
                        }
                    }
                ];
                options.callback = function(data) {
                    var options = {
                        success: function(data) {
                            var formIsOk = MyForm.processJson(data, formId);
                            if (formIsOk) {
                                MyWindow.close();
                                if (ids.length > 1) {
                                    Push.success(self.translations.successAddLinkedBatch)
                                } else {
                                    Push.success(self.translations.successAddLinked)
                                }
                                Listing.update(EmailBox.settings.listing);
                            }
                        },
                        dataType: "json",
                        data: {action: "linkPeople"}
                    };

                    MyForm.prepare(formId, "emailBox", options, true);
                    MyFacture.customForm();

                    $(self.selectors.inputNewPeople).trigger('click');
                    People.switchLinkToForm();
                };
                MyWindow.load("people", {action: "linkToForm", linkedid : ids, folder: folder, linkedtype : 'email'}, options);
                break;
            case 'opportunity':
                var formId = 'emailLinkOpportunityForm';
                options.buttons	= [
                    {
                        text : EmailBox.translations.btnCancel,
                        class: 'btn btn-default',
                        click : function(){
                            $(this).dialog("close");
                        }
                    },
                    {
                        text : self.translations.btnLink,
                        class: 'btn btn-primary',
                        click : function(){
                            $("#"+formId).submit();
                        }
                    }
                ];
                options.callback = function(data) {
                    var options = {success:function(data) {
                        var formIsOk = MyForm.processJson(data, formId);
                        if (formIsOk) {
                            MyWindow.close();
                            if (ids.length > 1) {
                                Push.success(self.translations.successAddLinkedBatch)
                            } else {
                                Push.success(self.translations.successAddLinked)
                            }
                            Listing.update(EmailBox.settings.listing);
                        }
                    },
                        dataType: "json",
                        data: {action: "linkOpportunity", opportunityLinked: 'new'}
                    };
                    MyForm.prepare(formId, "emailBox", options, true);
                    MyFacture.customForm();

                    // Force create opportunity
                    $(self.selectors.inputNewOpportunity).trigger('click');
                    $('#newOpportunity').show();
                    Opportunity.initAddForm();
                    MyFacture.customForm();
                };
                MyWindow.load(EmailBox.settings.route, {action: 'linkOpportunityForm', ids: ids, folder: folder, type: type}, options);
                break;
        }
    },

    /**
     * Delete link on an object
     * @param int id
     */
    delete: function(id)
    {
        var self = this;
        // Delete link
        MyWindow.wait();
        MyFacture.post(EmailBox.settings.route, {action: 'deleteLink', id: id}, function(data) {
            if (data.success) {
                MyWindow.awake();
                MyWindow.close();
                Push.success(self.translations.successDeleteLinked);
                if ($('#'+self.settings.listing).length > 0) {
                    Listing.update(self.settings.listing);
                } else {
                    Listing.update(EmailBox.settings.listing);
                }
            } else {
                MyWindow.close();
                Push.error(self.translations.errorDeleteLinked);
            }
        }, 'json');
    },
    /**
     * Alert for confirm deletion
     * @param string id
     */
    confirmDelete: function(id)
    {
        var self = this;
        var options = {
            resizable	: false,
            noclose		: true,
            type		: "warning",
            buttons		: [
                {
                    text : self.translations.btnDelete,
                    click : function() {
                        self.delete(id);
                        $(this).dialog("close");
                    }
                },
                {text : EmailBox.translations.btnCancel, click : function() { $(this).dialog("close"); } }
            ]
        };

        MyWindow.alert(self.translations.confirmDelete, options);
    },
    /**
     * Autocomplete link object
     */
    search: function()
    {
        var self   = this;
        var select = $(self.selectors.select);
        var type   = select.val();
        
        $(self.selectors.wrapper).find('.token-input-list').remove();

        switch (type) {
            case "people":
                TokenInput.autoPeople(self.selectors.search, 1, 'false', '', function(item) {
                    self.cleanRadio();
                });
                break;
            case "contact":
                TokenInput.autoContactListing(self.selectors.search, 'third|prospect|supplier|', 1, 'false', '', function(item) {
                    self.cleanRadio();
                    $(self.selectors.contact).tokenInput('clear');
                    var id = item.id.replace('corporation_', '');
                    // Add thirdid to contact autocomplete
                    $(self.selectors.contact).tokenInput('more', 'thirdid_'+id);
                }, function(item) {
                    $(self.selectors.contact).tokenInput('clear');
                    $(self.selectors.contact).tokenInput('more', '');
                });
                break;
            case "opportunity":
                TokenInput.autoOpportunity(self.selectors.search, function(item) {
                    self.cleanRadio();
                }, undefined, undefined, 'false');
                break;
            case "proposal":
                TokenInput.autoProposal(self.selectors.search, 'propdocument', 1, null, function (item) {
                    self.cleanRadio();
                }, 'false');
                break;
        }
    },
    /**
     * Reset all input[radio] from modal link
     */
    cleanRadio: function()
    {
        var self = this;
        $(self.selectors.wrapper).find('input[name="type"]').prop('checked', false);
    },
    /**
     * Enable/disabled valid button
     * @param bool isEnabled
     */
    isEnabled: function(isEnabled)
    {
        var self = this;
        var btn = $(self.selectors.validBtn);
        if (true == isEnabled) {
            btn.removeClass('btn btn-disabled');
            btn.attr('disabled', false);
        } else {
            btn.addClass('btn btn-disabled');
            btn.attr('disabled', 'disabled');
        }
    },
    /**
     * Show/hide contact group of third
     * @param bool show
     */
    toggleContact: function(show)
    {
        var self = this;
        if (show) {
            $(self.selectors.contactGroup).show();
        } else {
            $(self.selectors.contactGroup).hide();
        }
    }
};
